import {
  orange700 as Orange,
  cyan700 as Cyan,
  brown500 as Brown,
  red500 as Red,
} from 'material-ui/styles/colors';
import MobChowAPI from './MobChowAPI';
import {
  LOGIN,
  LOGIN_SUCESS,
  GET_DASHBOARD_CUSTOMERS,
  GET_DASHBOARD_ORDERS,
  GET_DASHBOARD_CUSTOMERS_SUCCESS,
  GET_DASHBOARD_ORDERS_SUCCESS,
  GET_ORDERS,
  GET_ORDERS_SUCCESS,
  GET_STATS,
  GET_STATS_SUCCESS,
} from '../actions/types';

const Api = new MobChowAPI();

import firebase from '../firebase';

const DataService = store => next => (action) => {
  switch (action.type) {
    case LOGIN: {
      const { email, password } = action.payload;
      return firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(() =>
          next({
            type: LOGIN_SUCESS,
          }),
        )
        .catch({
          type: 'LOGIN_ERROR',
        });
    }
    // return Api.login(action.payload).then(response =>
    //   next({
    //     type: LOGIN_SUCESS,
    //   }),
    // );

    case GET_STATS:
      // return Promise.all([
      //   Api.getRevenue(action.payload.range),
      //   Api.getOrdersCount(action.payload.range),
      //   Api.getInstallationCount(action.payload.range),
      //   Api.getUserCount(action.payload.range),
      // ]).then((results) => {
      next({
        type: GET_STATS_SUCCESS,
        payload: [
          {
            // value: `$${results[0].total.toFixed(2)}`,
            value: '$34,565.00',
            label: 'Revenue',
            color: 'white',
            background: Cyan,
          },
          {
            // value: results[1].data.length,
            value: 367,
            label: 'Orders',
            color: 'white',
            background: Brown,
          },
          {
            // value: results[2].data.length,
            value: 435,
            label: 'Installs',
            color: 'white',
            background: Red,
          },
          {
            // value: results[3].data.length,
            value: 310,
            label: 'Customers',
            color: 'white',
            background: Orange,
          },
        ],
      });
    // });

    case GET_DASHBOARD_CUSTOMERS:
      return Api.getCustomers(action.payload).then(response =>
        next({
          type: GET_DASHBOARD_CUSTOMERS_SUCCESS,
          payload: response.data,
        }),
      );

    case GET_DASHBOARD_ORDERS: {
      const { payload: { restaurantId } } = action;

      return firebase
        .firestore()
        .collection('restaurants')
        .doc(restaurantId)
        .collection('orders')
        .get()
        .then((querySnapshot) => {
          const orders = [];
          querySnapshot.forEach((docSnap) => {
            orders.push(docSnap.data());
          });
          next({
            type: GET_DASHBOARD_ORDERS_SUCCESS,
            payload: orders,
          });
        });
    }
    case GET_ORDERS:
      return Api.getOrders(action.payload).then(response =>
        next({
          type: GET_ORDERS_SUCCESS,
          payload: response.data,
        }),
      );

    default:
      return next(action);
  }
};

export default DataService;



// WEBPACK FOOTER //
// ./src/data/DataService.js